import { Router, Event, NavigationEnd } from '@angular/router';
import { Component, HostBinding, OnInit, Optional } from '@angular/core';
import { WorkforceAppComponent } from 'src/app/workforce/app.wf.component';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'integrations',
    templateUrl: './integrations.component.html',
    styleUrls: ['./integrations.component.scss'],
    standalone: false
})
export class IntegrationsComponent implements OnInit {
  // The Workforce shell provides no content padding; pad ourselves when
  // rendered inside it (the GLD shell pads its content container).
  @HostBinding('class') get hostPadding(): string {
    return this.wfParent ? 'tw-box-border tw-block tw-p-4 md:tw-p-8' : '';
  }

  constructor(
    private router: Router,
    @Optional() public wfParent: WorkforceAppComponent | null
  ) {}

  ngOnInit() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        // Type guard to confirm the event type
        if (event instanceof NavigationEnd) {
          if (event.url === '/integrations') {
            this.router.navigate(['/available-integrations']);
          }
        }
      });
  }
}
